// src/main.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// ✅ PWA 서비스워커 등록: 프로덕션에서만 동적 임포트
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  import('virtual:pwa-register')
    .then(({ registerSW }) => {
      registerSW({
        immediate: true,
        onNeedRefresh() {
          console.log('새 버전이 준비되었습니다. 새로고침해주세요.')
          // 필요시 여기서 UI 띄워 강제 새로고침 버튼 제공 가능
        },
        onOfflineReady() {
          console.log('오프라인에서도 사용할 수 있습니다.')
        }
      })
    })
    .catch((err) => {
      console.error('SW 등록 실패:', err)
    })
}

// AuthProvider import
import { AuthProvider } from './providers/AuthProvider'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
)

